import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlUtilService } from '../url/url.util.service';
import { catchError, finalize, first, map, Observable } from 'rxjs';
import { SpinnerService } from '../spinner.service';
import { ReponseCoordonneesMouvement } from '../../api/model/reponse-coordonnees-mouvement.model';
import { ParticulierMouvement } from '../../api/model/particulier-mouvement.model';
import { Environment } from '../../../environments/environment.class';
import { RequeteModifierCoordonneesMouvement } from '../../api/model/requete-modifier-coordonnees-mouvement.model';
import { ReponseModifierCoordonneesMouvement } from 'src/app/api/model/reponse-modifier-coordonnees-mouvement.model';

@Injectable({
  providedIn: 'root',
})
export class ChangementCoordonneeMouvementService {
  private static readonly MSG_ERREUR_GET =
    'Erreur lors de la récupération des coordonnées mouvement';

  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlUtilService);
  readonly spinnerService = inject(SpinnerService);
  private readonly environment = inject(Environment);

  constructor() {}

  obtenirCoordonnees$(): Observable<ParticulierMouvement> {
    this.spinnerService.afficher();
    return this.httpClient
      .get<ReponseCoordonneesMouvement>(
        this.urlService.getChangementCoordonneesMouvementUrl(this.environment.mouvementEndpoint),
      )
      .pipe(
        first(),
        map((data) => this.toCoordonneesMouvement(data)),
        catchError((err) => {
          throw err;
        }),
        finalize(() => this.spinnerService.cacher()),
      );
  }

  private toCoordonneesMouvement(reponse: ReponseCoordonneesMouvement): ParticulierMouvement {
    if (reponse?.particulierMouvement == null) {
      throw new Error(ChangementCoordonneeMouvementService.MSG_ERREUR_GET);
    }

    return reponse.particulierMouvement;
  }

  modifierCoordonnees$(
    payload: RequeteModifierCoordonneesMouvement,
  ): Observable<ReponseModifierCoordonneesMouvement | null> {
    this.spinnerService.afficher();
    return this.httpClient
      .patch<ReponseModifierCoordonneesMouvement>(
        this.urlService.getChangementCoordonneesMouvementUrl(this.environment.mouvementEndpoint),
        payload,
      )
      .pipe(
        catchError((err) => {
          throw err;
        }),
        finalize(() => this.spinnerService.cacher()),
      );
  }
}
